export default (error) => {
    let err = 'Falha ao concluir a requisição';
    if (!!error?.message) err = error.message;
    return err;
}